import React from 'react';

import { MultiSelect } from '@gogame/components';
import { useScreenDispatch } from '@gogame/screens';

import { SET_CHART_METRICS } from 'scenes/Trackers/Tracker/reducers';

import { useChartIndex, useChartState } from '../hooks';

export const SelectMetrics = ({ metrics, loading }) => {
  const chartIndex = useChartIndex();
  const temporaryChartState = useChartState(true);
  const dispatch = useScreenDispatch();

  const onChangeMetrics = (_e, value) => {
    dispatch({
      type: SET_CHART_METRICS,
      payload: {
        index: chartIndex,
        value: value,
      },
    });
  };

  return (
    <MultiSelect
      style={{ maxWidth: '216px', marginRight: '16px' }}
      options={metrics}
      label={'Metrics'}
      groupBy={'groupName'}
      loading={loading}
      value={temporaryChartState.metrics}
      onChange={onChangeMetrics}
      dropdownWidth={500}
      multipleSearch={true}
    />
  );
};
